import SysMsgService from "@/service/SysMsgService";
export const SysMsgStore = {
  namespaced: true,
  state: {
    dict: {},
    sysMsg: {}
  },
  actions: {
    async refreshStore({ commit }, action) {
      commit("refreshStore", action.payload);
    },
    async getFromStore({ commit }, lang) {
      //const response = await SysMsgService.getMsg(lang);
      //commit('refreshStore');
    },
    async GET_MESSAGE_FROM_API({ commit }, action) {
      const response = await SysMsgService.getMsg(action.payload.lang);
      if (response.data.IsSuccess) {
        commit("refreshStore", response.data.Data);
        //SweetAlertService.success("Success", 'SSS');
      }
    }
  },
  getters: {
    sysMsg: state => {
      return state.dict;
    }
  },
  mutations: {
    refreshStore(state, payload) {
      let obj = {};
      for (let i = 0; i < payload.length; i++) {
        obj[payload[i].FieldName] = payload[i].MsgString;
      }
      state.dict = obj;
    },
    setSysMsg(state, payload) {
      const list = Object.keys(state.dict);
      let obj = {}
      for (const item of list) {
        obj[item] = item
      }
      state.sysMsg = obj;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/SysMsgStore/SysMsgStore.js